import { useTranslation } from "react-i18next";
import i18n, { translate as tr } from "../../i18n";
import React, { lazy, Suspense } from "react";
import { connect } from "react-redux";
import Sidebar from "../common/sidebar";
import Loader from "../common/loader";
import Footer from "../common/footer";

const ClientList = lazy(() => import("../client/ClientList"));

class Clients extends React.Component {
  handleLanguageChange = () => this.forceUpdate();
  componentDidMount() { i18n.on("languageChanged", this.handleLanguageChange); }
  componentWillUnmount() { i18n.off("languageChanged", this.handleLanguageChange); }

  constructor(props) {
    super();
    this.state = {
      reload    : 0,
      clientTerm: "",
      sortBy    : "newest", // 'newest' | 'az' | 'za'
    };
  }

  reload    = () => this.setState({ reload: this.state.reload + 1 });

  handleSearchTerm = (e) => {
    this.setState({ clientTerm: e.target.value });
  };

  selectSort = (sortBy) => {
    this.setState({ sortBy, reload: this.state.reload + 1 });
  };

  render() {
    const { reload, clientTerm, sortBy } = this.state;
    const canManageClients = ["ADMIN", "MANAGER"].includes(this.props.auth?.workspace_role);
    return (
      <div>
        <Sidebar />

        {/* ── Page header ── */}
        <div className='header'>
          <div className='container-fluid'>
            <div className='row' style={{ flexDirection: 'column' }}>
              <div className='dash-page-header'>
                <div className='dash-page-title'>
                  <h1>{tr("Clients")}</h1>
                  <p>{tr("Manage customer billing profiles, invoice recipients, and finance-ready records.")}</p>
                </div>
                <div className='reports-right-item-cont tags-right-header-item'>
                  {canManageClients && (
                    <div className='create-new-tag-btn'>
                      <button id='add-new-button' onClick={() => this.props.history.push('/clients/new')}>
                        <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'>
                          <path fill='#ffffff' fillRule='evenodd'
                            d='M9 9V5.002a.999.999 0 1 1 2 0V9h3.998a.999.999 0 1 1 0 2H11v3.998a.999.999 0 1 1-2 0V11H5.002a.999.999 0 1 1 0-2H9z'/>
                        </svg>
                        <span>{tr("New client profile")}</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* ── Toolbar — mirrors Projects.js exactly ── */}
              <div className='proj-toolbar client-filter-toolbar'>

                {/* Sort tabs (mirrors status tabs in projects) */}
                <div className='proj-status-tabs'>
                  <button
                    className={sortBy === 'newest' ? 'proj-tab proj-tab--active' : 'proj-tab'}
                    onClick={() => this.selectSort('newest')}
                  >{tr("Newest")} </button>
                  <button
                    className={sortBy === 'az' ? 'proj-tab proj-tab--active' : 'proj-tab'}
                    onClick={() => this.selectSort('az')}
                  >{tr("A → Z")} </button>
                  <button
                    className={sortBy === 'za' ? 'proj-tab proj-tab--active' : 'proj-tab'}
                    onClick={() => this.selectSort('za')}
                  >{tr("Z → A")} </button>
                </div>

                <div className='proj-toolbar-sep' />

                {/* Search */}
                <div className='proj-search-wrap'>
                  <svg width='14' height='14' viewBox='0 0 14 14' fill='none'>
                    <circle cx='6' cy='6' r='4.5' stroke='#9ca3af' strokeWidth='1.5'/>
                    <path d='M10 10l2.5 2.5' stroke='#9ca3af' strokeWidth='1.5' strokeLinecap='round'/>
                  </svg>
                  <input
                    type='text'
                    className='proj-search-input'
                    placeholder={tr("Search clients…")}
                    value={clientTerm}
                    onChange={this.handleSearchTerm}
                    onKeyUp={this.reload}
                  />
                </div>

                {/* Clear search — only shown when active */}
                {clientTerm.length > 0 && (
                  <button
                    className='proj-filter-pill'
                    style={{ color: '#9ca3af', borderStyle: 'dashed' }}
                    onClick={() => this.setState({ clientTerm: '' }, this.reload)}
                  >
                    <svg width='12' height='12' viewBox='0 0 12 12' fill='none'>
                      <path d='M2 2l8 8M10 2l-8 8' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round'/>
                    </svg>{tr("Clear")} </button>
                )}
              </div>

            </div>
          </div>
        </div>

        <Suspense fallback={<Loader />}>
          <ClientList reload={reload} searchTerm={clientTerm} sortBy={sortBy} />
        </Suspense>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(Clients);
